import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import numeral from 'numeral';

import icons from '../../../components/IconsList';
import { colors } from '../../../styles';

const styles = css`
  @media(min-width: 992px) {
    border-left: 1px solid #D3D3D3;
  }
  .PlanBeds_price {
    font-weight: 700;
    font-size: 13px;
    color: #171717;
    letter-spacing: 0;
    border: 1px solid #DADADA;
    margin: 0;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media(min-width: 992px) {
      padding: 0;
      border: 0;
      font-weight: 300;
      font-size: 28px;
      color: #000000;
      line-height: 35px;
    }
  }
  .PlanBeds_list {
    flex-wrap: wrap;
    justify-content: start;
    column-gap: 20px;
    row-gap: 30px;
    @media(min-width:992px) {
      justify-content: start;
    }
    li {
      padding: 0 0 0 20px;
      font-size: 12px;
      color: #171717;
      letter-spacing: 0;
      background-repeat: no-repeat;
      background-position: left center;
      display: flex;
      align-items: center;
      margin-left: 10px;
      @media(min-width: 310px) {
        font-size: 13px;
      }
      @media(min-width: 400px) {
        padding: 0 20px 0 25px;
      }
      @media(min-width: 992px) {
        font-size: 15px;
        background-size: 20px 20px;
      }
      /* & + li {
        margin: 0 0 0 10px;
      } */
    }
  }
  b {
    font-weight: 700;
    color: ${colors.text};
  }
`;

function PlanPrice({ plan, className }) {
  return (
    <div className={`${className} ${styles}`}>
      {
        get(plan, 'custom_price_display') &&
        <div className="d-flex pt-lg-2 pl-lg-2 pl-xl-5 ml-2">
          <h4 className="PlanBeds_price mr-auto mr-sm-2 mr-lg-auto">Price:&nbsp;<b>{get(plan, 'custom_price_display')}</b></h4>
        </div>
      }
      <ul className="list-unstyled d-flex PlanBeds_list m-0 py-3 py-lg-4 pl-lg-2 pl-xl-5">
        <li className="PlanBeds_listItem" style={{ backgroundImage: `url(${icons.beds})` }}>
          <b>{get(plan, 'beds')}</b>&nbsp;Beds
        </li>
        <li className="PlanBeds_listItem" style={{ backgroundImage: `url(${icons.baths})` }}>
          <b>{get(plan, 'bathsFull')}{get(plan, 'bathsHalf', 0) > 0 ? '.5' : ''}</b>&nbsp;Baths
        </li>
        <li className="PlanBeds_listItem" style={{ backgroundImage: `url(${icons.sqft})` }}>
          <b>{numeral(plan.sqft).format('0,0')}</b>&nbsp;SQFT
        </li>
      </ul>
      <ul className="list-unstyled d-flex PlanBeds_list m-0 py-3 py-lg-4 pl-lg-2 pl-xl-5">
        {
          get(plan, 'stories') &&
          <li className="PlanBeds_listItem" style={{ backgroundImage: `url(${icons.stairs})` }}>&nbsp;<b>{get(plan, 'stories')}&nbsp;</b>{plan.stories === 1 ? ' Story' : ' Stories'}</li>
        }
        {
          get(plan, 'garages') &&
          <li className="PlanBeds_listItem" style={{ backgroundImage: `url(${icons.garage})` }}>&nbsp;<b>{get(plan, 'garages')}</b>-Car Garage</li>
        }
      </ul>
    </div>
  );
}

PlanPrice.propTypes = {
  plan: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
};

export default withData(
  {
    plan: true,
  },
)(PlanPrice);



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/PlanDetails/PlanBeds.js